export enum PropertyPageEnum {
  Address = 'Address',
  AdditionalInfo = 'AdditionalInfo',
  Overview = 'Overview',
}
